import UniversalFooter from "../../../components/UniversalFooter";
import UniversalMenuHeader from "../../../components/UniversalMenuHeader";
import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

//Imports de los modals
import UModalLogin from "../../../components/UModalLogin/UModalLogin.jsx";
import UModalContactanos from "../../../components/UModalContactanos/UModalContactanos.jsx";
import UModalEnviarCorreo from "../../../components/UModalEnviarCorreo/UModalEnviarCorreo.jsx";
import UModalCambiarContraseñaTemporal from "../../../components/UModalCambiarContraseñaTemporal/UModalCambiarContraseñaTemporal.jsx";
import UModalRecetContraseña from "../../../components/UModalRecetContraseña/UModalRecetContraseña.jsx";

import { useNavigate } from "react-router-dom";
import { WindowSizeContext } from "../../../context/WindowSizeContext.jsx"; //Se usa para calcular el ancho de los modals
//________________________//

export default function Nosotros() {
  // Variables para los modals (Extraidos de HOME PUBLICO)
  let [searchParams] = useSearchParams();
  const [vIsModal, setVIsModal] = useState(false);
  const [vIsLogin, setVIsLogin] = useState(false);
  const [vIsEnviarCorreo, setEnviarCorreo] = useState(false);
  const [vIsCambioContraseñaTemporal, setCambioContraseñaTemporal] =
    useState(false);
  const [vIsRecetContraseña, setRecetContraseña] = useState(false);
  const [vIsContactanos, setVIsContactanos] = useState(false);

  const { width,height } = useContext(WindowSizeContext); // Se usa para calcular el tamaño de los MODALS
  const [vWidth, setVWidth] = useState(width - 20);

  const navigate = useNavigate();
  const irACursos = () => {
    navigate("/cursos");
  };
  //_________________________________________________________________________________//

  // UseEffect de los modals (Extraidos de HOME PUBLICO)
  useEffect(() => {
    if (searchParams.get("_tk")) {
      //localStorage.clear()
      localStorage.setItem("token", searchParams.get("_tk"));
      if (searchParams.get("_m") && searchParams.get("_m") == "reset") {
        mActivar_DesactivarModal("recetContraseña", true);
      } else {
        mActivar_DesactivarModal("cambiarContraseñaTemporal", true);
      }
    } else {
      mActivar_DesactivarModal();
    }
  }, [searchParams]);

  const mActivar_DesactivarModal = (vModalActivar, vIsActivo) => {
    const mResetearModals = () => {
      setEnviarCorreo(false);
      setCambioContraseñaTemporal(false);
      setRecetContraseña(false);
      setVIsLogin(false);
      setVIsContactanos(false);
    };
    setVIsModal(vIsActivo);
    if (!vIsActivo) {
      mResetearModals();
    } else {
      switch (vModalActivar) {
        case "enviarCorreo":
          mResetearModals();
          setEnviarCorreo(true);
          break;
        case "cambiarContraseñaTemporal":
          mResetearModals();
          setCambioContraseñaTemporal(true);
          break;
        case "recetContraseña":
          mResetearModals();
          setRecetContraseña(true);
          break;
        case "contactanos":
          mResetearModals();
          setVIsContactanos(true);

          break;
        case "login":
          mResetearModals();
          setVIsLogin(true);
          break;
        case "login":
          mResetearModals();
          setVIsLogin(true);
          break;

        default:
          mResetearModals();
          break;
      }
    }
  };
  //_____________________________________________________//

  return (
    <div class="nosotros-desktop" style={!vIsModal ? { width: vWidth } : {  height: height}}>
      <div data-figma-id="420:11610" class="nosotros-header-2" style={!vIsModal ? { width: vWidth } : {  height: height,maxHeight: height}}>
        <UniversalMenuHeader
          mActivar_DesactivarModal={mActivar_DesactivarModal}
          nombrePaginaSeleccionada="Nosotros"
        />

        {/* Insercion de los modals */}
        <UModalLogin
          vIsLogin={vIsLogin}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        <UModalEnviarCorreo
          vIsEnviarCorreo={vIsEnviarCorreo}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        <UModalContactanos
          vIsContactanos={vIsContactanos}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        {vIsCambioContraseñaTemporal && (
          <UModalCambiarContraseñaTemporal
            vIsCambioContraseñaTemporal={vIsCambioContraseñaTemporal}
            mActivar_DesactivarModal={mActivar_DesactivarModal}
          />
        )}
        {vIsRecetContraseña && (
          <UModalRecetContraseña
            vIsRecetContraseña={vIsRecetContraseña}
            mActivar_DesactivarModal={mActivar_DesactivarModal}
          />
        )}
        {/* _______________________________ */}
        {(!vIsModal || (width > 1439 && vIsModal)) && (
          <div data-figma-id="394:11247" class="nosotro-header-frase">
            <p data-figma-id="394:11248" class="nosotro-header-frase-texto-1">
              &quot;Si un hombre vacía su monedero en su cabeza, nadie se lo
              podrá quitar. La inversión en el conocimiento siempre paga el
              mejor interés.&quot;
            </p>
            <p data-figma-id="394:11249" class="nosotro-header-frase-texto-2">
              Benjamin Franklin
            </p>
          </div>
        )}
      </div>
      {(!vIsModal || (width > 1439 && vIsModal)) && (
        <>
          <div data-figma-id="582:13004" class="nosotros-info-1">
            <div class="div-block-6">
              <p data-figma-id="581:12947" class="nosotros-info-1-texto-1">
                ¿Quiénes somos?
              </p>
            </div>
            <div class="nosotros-linea-copy"></div>
            <div data-figma-id="581:12949" class="nosotros-info-1-contenido">
              <p
                data-figma-id="581:12950"
                class="nosotros-info-1-contenido-texto-1 truncate-6-line"
              >
                MHM Group es la verdadera evolución de la Capacitación
                Financiera de alto nivel en México y América Latina, es un
                movimiento que tiene sus raíces en un grupo de empresarios y
                colaboradores que cuentan con toda la experiencia en el ramo.
              </p>

              <div class="nosotros-linea"></div>
              <p
                data-figma-id="581:12952"
                class="nosotros-info-1-contenido-texto-2 truncate-6-line"
              >
                {" "}
                Generamos experiencias únicas de aprendizaje y desarrollo, de la
                mano de nuestros expertos expositores quienes verdaderamente
                dominan los temas que profesan, sin enredos, sin complejidades.
              </p>
            </div>
          </div>
          <div data-figma-id="587:13019" class="nosotros-info-2">
            <p data-figma-id="581:12954" class="nosotros-info-2-texto">
              Bienvenido a la nueva era de la capacitación financiera
              especializada
            </p>
          </div>
          <div data-figma-id="598:13026" class="nosotros-info-3">
            <div data-figma-id="581:12956" class="nosotros-info-3-contenido">
              <div
                data-figma-id="598:13020"
                class="nosotros-info-3-contenido-2"
              >
                <img
                  src="images/imagen-manos-entrelazadas-1.png"
                  data-figma-image-id="67abf2e814fd3aa17e998dbc"
                  alt=""
                  data-figma-id="598:13021"
                  data-figma-image-hash="5d8e4fd624a1d9a260a1660bae410d03"
                  loading="lazy"
                />
                <p
                  data-figma-id="598:13022"
                  class="somos-los-aliados-estratgicos-de-nuestros-clientes-en-capacitacin-y-formacin-continua truncate-4-line"
                >
                  Somos los aliados estratégicos de nuestros clientes en
                  capacitación y formación continua.
                </p>
              </div>
              <div
                data-figma-id="598:13023"
                class="nosotros-info-3-contenido-2"
              >
                <img
                  src="images/imagen-idea-1.png"
                  data-figma-image-id="67abf2e91554609c2814a4de"
                  alt=""
                  data-figma-id="598:13024"
                  data-figma-image-hash="5897fb75d4a794aeb08231f1e0203e66"
                  loading="lazy"
                />
                <p
                  data-figma-id="598:13025"
                  class="imagen-idea-1-texto truncate-4-line"
                >
                  Somos especialistas en dar solución a necesidades educativas
                  complejas en diversos temas y proyectos.
                </p>
              </div>
            </div>
            <div data-figma-id="581:12959" class="nosotros-info-3-texto">
              <p data-figma-id="581:12959 - 0" class="nosotros-info-3-texto-2">
                En palabras simples,
              </p>
              <p data-figma-id="581:12959 - 1" class="nosotros-info-3-texto-3">
                {" "}
                somos los mejores en lo que hacemos
              </p>
            </div>
          </div>
          <div class="section-objetivo">
            <img
              sizes="100vw"
              srcset="images/nuestro-manifiesto-p-500.png 500w, images/nuestro-manifiesto-p-800.png 800w, images/nuestro-manifiesto-p-1080.png 1080w, images/nuestro-manifiesto-p-1600.png 1600w, images/nuestro-manifiesto-p-2000.png 2000w, images/nuestro-manifiesto-p-2600.png 2600w, images/nuestro-manifiesto.png 3064w"
              alt=""
              src="images/nuestro-manifiesto.png"
              loading="lazy"
              class="image-10---alterno"
            />
            <img
              sizes="(max-width: 991px) 100vw, 50vw"
              srcset="images/razon_de_ser-p-500.png 500w, images/razon_de_ser-p-800.png 800w, images/razon_de_ser-p-1080.png 1080w, images/razon_de_ser-p-1600.png 1600w, images/razon_de_ser-p-2000.png 2000w, images/razon_de_ser-p-2600.png 2600w, images/razon_de_ser.png 3064w"
              alt=""
              src="images/razon_de_ser.png"
              loading="lazy"
              class="image-10"
            />
            <img
              sizes="(max-width: 991px) 100vw, 50vw"
              srcset="images/lideres_dtech-p-500.png 500w, images/lideres_dtech-p-800.png 800w, images/lideres_dtech-p-1080.png 1080w, images/lideres_dtech-p-1600.png 1600w, images/lideres_dtech-p-2000.png 2000w, images/lideres_dtech-p-2600.png 2600w, images/lideres_dtech.png 3064w"
              alt=""
              src="images/lideres_dtech.png"
              loading="lazy"
              class="image-9"
            />
            <img
              sizes="100vw"
              srcset="images/razon-de-ser-MHM-2-p-500.png 500w, images/razon-de-ser-MHM-2-p-800.png 800w, images/razon-de-ser-MHM-2.png 1200w"
              alt=""
              src="images/razon-de-ser-MHM-2.png"
              loading="lazy"
              class="image-9---alterno"
            />
          </div>
          <div data-figma-id="614:12663" class="nosotros-info-5">
            <div class="div-block-5">
              <p data-figma-id="581:12964" class="nosotros-info-5-texto-1">
                Nuestros expositores
              </p>
            </div>
            <div class="nosotros-linea"></div>
            <p data-figma-id="581:12966" class="nosotros-info-5-texto-2">
              Día con día aumentamos nuestro gran repertorio de Expertos
              Expositores, junto con quienes nos sentimos orgullosos de apoyar
              al desarrollo profesional de nuestros clientes y de nuestros
              alumnos, quienes depositan en nosotros su confianza y la gran
              responsabilidad de enseñar.
            </p>
          </div>
          <UniversalFooter />
        </>
      )}
    </div>
  );
}
